// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Warp Gates Configuration - Universe Improbability Sector
 * 
 * Gate back to Milky Way universe. Because you can't stay in the Improbability Sector forever.
 * (Well, you could, but the probability of that is exactly 1 in infinity to the power of infinity.)
 */

export const warpGates = [
  {
    id: 'gate_improbability_to_discworld',
    name: 'DISCWORLD GATEWAY',
    type: 'warpgate',
    distance: 280, // Much closer - between Kakrafoon and Ursa Minor Beta
    destinationUniverse: 'discworld',
    destinationGate: 'gate_discworld_to_improbability',
    toSystem: 500,
    fuelRequired: 10,
    threat: 'NARRATIVE',
    resources: 'STORY LOGIC',
    services: ['refuel'],
    primaryColor: '#8B4513', // Brown like the Disc
    secondaryColor: '#FFD700', // Gold like magic
    hasRings: true, // Enable rings for visual effect during warp
    animated: true,
    discovered: false, // Must be found
    description: 'A gateway to a flat world where magic works and stories have power. Powered by narrative causality and the belief of millions.',
    scanDescription: 'ANALYSIS: Dimensional gateway to universe "Discworld". Reality operates on narrative principles. Magic detected. Recommend bringing sense of humor.',
  },
  {
    id: 'gate_improbability_to_neonmetropolis',
    name: 'NEON METROPOLIS GATEWAY',
    type: 'warpgate',
    distance: 320, // Far edge of the sector
    destinationUniverse: 'neonmetropolis',
    destinationGate: 'gate_neonmetropolis_to_improbability',
    fuelRequired: 10,
    threat: 'CORPORATE',
    resources: 'CHROME & NEON',
    services: [],
    primaryColor: '#00ffff', // Cyan
    secondaryColor: '#ff00ff', // Magenta
    hasRings: true,
    animated: true,
    discovered: false, // Must be found
    description: 'A gateway to a cyberpunk universe where megacorporations rule and neon bleeds through acid rain. Probability of corporate surveillance: 1 to 1.',
    scanDescription: 'ANALYSIS: Dimensional gateway to universe "Neon Metropolis". Corporate encryption detected. Neural virus warnings active. Recommend firewall upgrades.',
  }
];

// Warp gate positions on the map
export const warpGatePositions = {
  'gate_improbability_to_discworld': { x: 75, y: 35, z: -20 }, // Much closer position, between Kakrafoon and Ursa Minor Beta
  'gate_improbability_to_neonmetropolis': { x: 85, y: 65, z: 15 }, // Far edge of the sector
};
